import { welcomePopupKinds, welcomeActionKinds } from "./types";

const contents = {
	[welcomePopupKinds.Register]: {
		mainTitle: "app.IntroPopup.modal.mainTitle.registration",
		option1: {
			title: "app.IntroPopup.modal.title.createOrg",
			text: "app.IntroPopup.modal.text.createOrg",
			buttonText: "app.IntroPopup.modal.btn.createOrg",
			buttonAction: welcomeActionKinds.CreateOrg,
			image: "/images/HegiasIlluWelcomePopupCheckoutScenes.png",
		},
		option2: {
			title: "app.IntroPopup.modal.title.VROnBoarding",
			text: "app.IntroPopup.modal.text.VROnBoarding",
			buttonText: "app.IntroPopup.modal.btn.VROnBoarding",
			buttonAction: welcomeActionKinds.VROnBoarding,
			image: "/images/HegiasIlluGlasses.png",
		},
		/* option3: {
			title: "app.IntroPopup.modal.title.linkToSupportPage",
			text: "app.IntroPopup.modal.text.linkToSupportPage",
			buttonText: "app.IntroPopup.modal.btn.linkToSupportPage",
			buttonAction: welcomeActionKinds.LinkToSupportPage,
			image: "/images/HegiasIllu404.png",
		}, */
	},
	[welcomePopupKinds.RegisterByInvite]: {
		mainTitle: "app.IntroPopup.modal.mainTitle.invitation",
		option1: {
			title: "app.IntroPopup.modal.title.invitationTeamMember",
			text: "app.IntroPopup.modal.text.invitationTeamMember",
			buttonText: "app.IntroPopup.modal.btn.invitationTeamMember",
			buttonAction: welcomeActionKinds.InviteMember,
			image: "/images/HegiasIlluMembersIcon.png",
		},
		option2: {
			title: "app.IntroPopup.modal.title.firstUpload",
			text: "app.IntroPopup.modal.text.firstUpload",
			buttonText: "app.IntroPopup.modal.btn.firstUpload",
			buttonAction: welcomeActionKinds.FirstUpload,
			image: "/images/HegiasIlluCreateProjectAndScene.png",
		},
		/* option3: {
			title: "app.IntroPopup.modal.title.startTrial",
			text: "app.IntroPopup.modal.text.startTrial",
			buttonText: "app.IntroPopup.modal.btn.startTrial",
			buttonAction: welcomeActionKinds.startTrial,
			image: "/images/HegiasIlluWelcome.png",
		}, */
	},
	[welcomePopupKinds.OrganizationInvite]: {
		mainTitle: "app.IntroPopup.modal.mainTitle.invitation",
		option1: {
			title: "app.IntroPopup.modal.title.invitationTeamMember",
			text: "app.IntroPopup.modal.text.invitationTeamMember",
			buttonText: "app.IntroPopup.modal.btn.invitationTeamMember",
			buttonAction: welcomeActionKinds.InviteMember,
			image: "/images/HegiasIlluMembersIcon.png",
		},
		option2: {
			title: "app.IntroPopup.modal.title.firstUpload",
			text: "app.IntroPopup.modal.text.firstUpload",
			buttonText: "app.IntroPopup.modal.btn.firstUpload",
			buttonAction: welcomeActionKinds.FirstUpload,
			image: "/images/HegiasIlluCreateProjectAndScene.png",
		},
		/* option3: {
			title: "app.IntroPopup.modal.title.tutorial",
			text: "app.IntroPopup.modal.text.tutorial",
			buttonText: "app.IntroPopup.modal.btn.tutorial",
			buttonAction: welcomeActionKinds.tutorial,
			image: "/images/HegiasIlluBeRightBack.png",
		}, */
	},
	[welcomePopupKinds.CreateOrganization]: {
		mainTitle: "app.IntroPopup.modal.mainTitle.creation",
		option1: {
			title: "app.IntroPopup.modal.title.invitationTeamMember",
			text: "app.IntroPopup.modal.text.invitationTeamMember",
			buttonText: "app.IntroPopup.modal.btn.invitationTeamMember",
			buttonAction: welcomeActionKinds.InviteMember,
			image: "/images/HegiasIlluMembersIcon.png",
		},
		option2: {
			title: "app.IntroPopup.modal.title.firstUpload",
			text: "app.IntroPopup.modal.text.firstUpload",
			buttonText: "app.IntroPopup.modal.btn.firstUpload",
			buttonAction: welcomeActionKinds.FirstUpload,
			image: "/images/HegiasIlluCreateProjectAndScene.png",
		},
	},
};

export default contents;
